import React, { useState, useRef, useEffect } from "react";
import styles from "./CustomSelect.module.css";

export default function CustomSelect({
  name,
  options = [],
  value,
  onChange,
  placeholder = "Select",
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, []);

  const selected = options.find((o) => String(o.value) === String(value));

  function handleSelect(val) {
    const syntheticEvent = { target: { name, value: String(val) } };
    onChange && onChange(syntheticEvent);
    setOpen(false);
  }

  return (
    <div className={styles.container} ref={ref}>
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        className={styles.trigger}
        onClick={() => setOpen((s) => !s)}
      >
        <span>{selected ? selected.label : placeholder}</span>
        <span className={styles.chev}>▾</span>
      </button>

      {open && (
        <ul role="listbox" className={styles.options}>
          {options.map((opt) => {
            const isSelected = String(opt.value) === String(value);
            return (
              <li
                key={opt.value}
                role="option"
                aria-selected={isSelected}
                className={`${styles.option} ${isSelected ? styles.selected : ""}`}
                onClick={() => handleSelect(opt.value)}
              >
                {opt.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
